import {AfterViewInit, Component, ViewChild} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {GroupsComponent} from "./pages/groups/groups.component";
import {LoginComponent} from "./pages/login/login.component";
import {ToastModule} from "primeng/toast";
import {ImageEditorComponent} from "./shared/components/image-editor/image-editor.component";
import {Group, ImageDetail, ImageEditorImageType} from "./data/types/groups/types";
import {Make} from "./data/types/makes/types";

@Component({
  selector: 'app-root',
  standalone: true,
    imports: [RouterOutlet, GroupsComponent, LoginComponent, ToastModule, ImageEditorComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements  AfterViewInit{
  @ViewChild(ImageEditorComponent) imageEditor!: ImageEditorComponent;
  title = 'autotech-inspection';

  ngAfterViewInit() {
      // this.imageEditor.setImageType(ImageEditorImageType.SEARCH_IMAGE);
      // // @ts-ignore
      // this.imageEditor.setImage({webp: "4/6/5/spark-plugs-take-photo-replace-spark-plugs-spark-plugs-642318.webp"});
      // this.imageEditor.setGroup({
      //   id: 1,
      //   name: 'string',
      //   occurrence_rate: 1,
      //   upload_dialog_visible: false,
      //   search_dialog_visible: false,
      // })
      // this.imageEditor.setGroupSelectedMake({id: 1, name: 'Ford'} as Make)
  }
}
